const actions = {
    FETCH_MAIN_CLUBS: 'FETCH_MAIN_CLUBS',
    FETCH_MAIN_CLUB: 'FETCH_MAIN_CLUB',
    RESET_MAIN_CLUB: 'RESET_MAIN_CLUB',

    fetchMainClubsAction: (data) => {
        return {
            type: actions.FETCH_MAIN_CLUBS,
            data: data
        };
    },
    resetMainClubFormAction: () => {
        return {
            type: actions.RESET_MAIN_CLUB,
            data: null
        };
    },
    fetchMainClubAction: (data) => {
        return {
            type: actions.FETCH_MAIN_CLUB,
            data: data
        };
    },
};

export default actions;